import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

import { BtlTranslateServices } from '@base/services/btl-translate.services';

/**
 * btlTranslate="fiche_tel.titre-telephon" [translateParams]="{eco: 'world'}"
 */
@Directive({
    selector: '[data_bfkeylabel]',
})
export class BtlTranslateDirective implements OnInit {
    private key: string;
    private currentParams: any;

    @Input() set data_bfkeylabel(key: string) {
        if (key) {
            this.key = this.removePrefix(key);
            this.translate();
        }
    }

    @Input() set translateParams(params: any) {
        if (params) {
            this.currentParams = params;
            this.translate();
        }
    }

    constructor(
        private renderer: Renderer2,
        private element: ElementRef,
        private translateService: BtlTranslateServices,
    ) {}

    private removePrefix(key: string, prefix: string = 'boutique'): string {
        return key.split('.').reduce((acc, current) => (acc !== prefix ? `${acc}.${current}` : `${current}`));
    }

    private translate() {
        this.translateService.get(this.key, this.currentParams).subscribe((translateValue: string) => {
            if (this.key !== translateValue) {
                this.updateValue(this.key, translateValue);
            }
        });
    }

    public ngOnInit() {
        this.renderer.addClass(this.element.nativeElement, 'translate');
    }

    private updateValue(key: string, value: any) {
        const node: Node = this.element.nativeElement.childNodes[0];
        if (node) {
            this.setContent(node, !this.key ? node.nodeValue : value);
        }
    }

    private setContent(node: Node, content: string): void {
        if (typeof node.textContent !== 'undefined' && node.textContent !== null) {
            node.textContent = content;
        } else {
            node.nodeValue = content;
        }
    }
}
